export { default } from './Contenidor';
